import { useNudge } from '@cobliteam/hooks/src/useNudge';
import type { Nudge, NudgeSurface } from '@cobliteam/hooks/src/useNudge/types';
import { useTranslation } from '@cobliteam/i18n';
import CobliConectaSuggestionSlide from '../components/CobliConectaSuggestion/CobliConectaSuggestionSlide';
import { useShouldShowCobliConecta } from '../components/CobliConectaSuggestion/useShouldShowCobliConecta';

export const COBLI_CONECTA_NUDGE_ID = 'cobli-conecta-download';

/**
 * Suggestion, not recommendation: it is a deterministic check over the fleet's devices, with no AI
 * workflow and no recommendation back end behind it.
 */
export const useCobliConectaNudge = (surface: NudgeSurface = 'floating-card'): Nudge | null => {
  const { t } = useTranslation('suggestions');
  const { shouldShow, dismiss, accept } = useNudge({
    id: COBLI_CONECTA_NUDGE_ID,
    kind: 'suggestion',
    surface,
    useShouldShow: useShouldShowCobliConecta,
  });

  if (!shouldShow) return null;

  return {
    id: COBLI_CONECTA_NUDGE_ID,
    kind: 'suggestion',
    priority: 1,
    tagLabel: t('cobli_conecta.tag_label'),
    // Same key the slide's own heading uses, so collapsing and expanding read identically.
    title: t('cobli_conecta.title'),
    dismiss,
    render: () => <CobliConectaSuggestionSlide onAccept={accept} onDismiss={dismiss} />,
  };
};

export default useCobliConectaNudge;
